import StyledLink from '../StyledLink'
import {
  EDIT,
  SPACE_API_ACCESS
} from '../routes'
import type { Props as BaseProps } from '../types'

interface Props extends BaseProps {
  id: string
}

const LinkToEditSpaceApiAccess = ({
  children,
  isHyperlink,
  id
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SPACE_API_ACCESS + '/' + id + '/' + EDIT}
  >
    {children}
  </StyledLink>

export default LinkToEditSpaceApiAccess
